// extracted by mini-css-extract-plugin
export default {"container":"DocCard_container__8xsRo","body":"DocCard_body__rd-xX","body__txt":"DocCard_body__txt__j75ed","footer":"DocCard_footer__xLl1d"};